quoteModule.directive('priceEditor', function factory() {

    /**
     * PriceEditor Component
     * @returns {PriceEditor}
     * @constructor
     */
    function PriceEditor() {
        this.amount = angular.copy(this.rate.RatedTerms[0].RetailCost);
        this.dealerCost = this.rate.RatedTerms[0].DealerCost;
        this.baseDealerCost = false;
        this.hasBaseUpgrade = this.rate.BaseNoUpgradeProductRates;
        if(this.hasBaseUpgrade) {
            var baseRate = this.rate.BaseNoUpgradeProductRates[0];
            var baseTerm = baseRate.BaseRatedTerm;
            this.baseDealerCost = baseTerm.DealerCost;
        }

        return this;
    }


    /**
     * Get the base dealer price based on whether or not we are editing an upgrade rate.
     *
     * @returns {*}
     */
    PriceEditor.prototype.getDealerCost = function() {
        return this.baseDealerCost !== false ? this.baseDealerCost : this.dealerCost;
    };

    /**
     * Adjust the profit amount based on whether or not we are editing an upgrade rate.
     * @returns {number}
     */
    PriceEditor.prototype.getProfit = function() {
        var profit = (this.amount - this.getDealerCost() > 0 || this.retailBelowZero())
                ? this.amount - this.getDealerCost()
                : 0;
        return this.hasBaseUpgrade ? 0 : profit;
    };

    /**
     * Show the Upgrade Profit Section
     * @returns {null|*}
     */
    PriceEditor.prototype.showUpgradeSection = function() {
        return this.hasBaseUpgrade && this.showRegularSection();
    };

    /**
     * Show the Regular Profit Section.
     * @returns {*|boolean}
     */
    PriceEditor.prototype.showRegularSection = function() {
        var productId = this.rate.RatedProduct.InternalProductId;
        var costMode = this.queue.profitCostMode,
            display = (costMode[productId] && costMode[productId].displayProfitAndCost) || '';
        return display == 'ALWAYS';
    };

    /**
     * Update the retailCost and trigger an onUpdate event.
     */
    PriceEditor.prototype.update = function () {
        this.prevousAmount = angular.copy(this.rate.RatedTerms[0].RetailCost);
        this.rate.RatedTerms[0].RetailCost = angular.copy(this.amount);
        if(this.onUpdate && typeof this.onUpdate === 'function') {
            this.onUpdate(this.rate, this.prevousAmount);
        }
    };

    /**
     * Reset the retailCost and trigger an onCancel event.
     */
    PriceEditor.prototype.cancel = function () {
        this.amount = angular.copy(this.rate.RatedTerms[0].RetailCost);
        if(this.onCancel && typeof this.onCancel === 'function') {
            this.onCancel(this.rate);
        }
    };

    /**
     * Determine whether the price editor is in edit mode.
     * @returns {boolean}
     */
    PriceEditor.prototype.editing = function () {
        var appCode = this.rate.RatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode;
        appCode = appCode.toUpperCase();
        var priceEditing = this.queue.priceEditing[this.queue.currentScenarioId];
        return priceEditing ? priceEditing[appCode] : false;
    };

    /**
     * Determine whether the input is disabled or not.
     * @returns {boolean}
     */
    PriceEditor.prototype.inputDisabled = function () {
        return !(this.dealerCanModify);
    };

    PriceEditor.prototype.retailBelowZero = function () {
        return (this.allowRetailBelowZero);
    };

    /**
     * PriceEditor DDO
     */
    return {
        restrict: 'E',
        templateUrl: 'app/modules/quote/directives/price-editor.html',
        replace: true,
        transclude: false,
        controller: PriceEditor,
        controllerAs: 'editor',
        bindToController: true,
        scope: {
            rate: '=',
            queue: '=',
            onCancel: '=',
            onUpdate: '=',
            dealerCanModify: '=',
            allowRetailBelowZero: '='
        },
        link: function(scope, element, attrs, ctrl) {
        }
    };
});